import CapsuleitemScreen from './containers/capsuleitemScreen'

export {default as CapsuleitemScreenLayout} from './components/capsuleitemScreenLayout'

export default CapsuleitemScreen
